import React from 'react';

export default class UserSelect extends React.Component {
	constructor(props) {
		super(props);

		this.ref = React.createRef();
	}

	componentDidMount() {
		this.initSelect2();
	}

	initSelect2() {
		var self = this;

		if (this.ref.current) {
			$(this.ref.current)
				.select2({
					ajax: {
						url: self.props.endpoint,
						dataType: 'json',
						delay: 250,
						data: function(params) {
							return {
								q: params.term,
								page: params.page,
								results_per_page: 40
							};
						},
						processResults: function(resultData, params) {
							const { data, meta: { page } } = resultData;
							params.page = params.page || 1;

							return {
								results: data,
								pagination: {
									more: params.page * 40 < page.totalElements
								}
							};
						},
						cache: true
					},
					allowClear: false,
					escapeMarkup: function(markup) {
						return markup;
					},
					placeholder: I18n.t('admin.please_select'),
					templateResult: function(product) {
						return self.selectedOption(product);
					},
					templateSelection: function(product) {
						return self.selectedOption(product);
					}
				})
				.on('select2:unselect', function() {
					self.props.onChange(null);
				})
				.on('select2:select', function(selection) {
					self.props.onChange(selection.params.data);
				});
		}
	}

	render() {
		return (
			<div className="UserSelect">
				<select
					className="form-control"
					ref={this.ref}
					style={{ width: '100%', minHeight: 33 }}
				/>
			</div>
		);
	}

	selectedOption(user) {
		console.log('selectedOption', user);

		var displayName = '';
		var firstName = null;
		var lastName = null;
		var emailAddressPrincipal = null;

		user &&
			user.summary &&
			user.summary.names.map((name) => {
				if (name.key === 'firstName') {
					firstName = name.values[0] || '';
					// console.log('firstName', firstName);
				}
				if (name.key === 'lastName') {
					lastName = name.values[0] || '';
					// console.log('lastName', lastName);
				}
				if (name.key === 'emailAddressPrincipal') {
					emailAddressPrincipal = name.values[0] || '';
					// console.log('emailAddressPrincipal', emailAddressPrincipal);
				}
			});

		// console.log(
		// 	'firstName',
		// 	firstName,
		// 	'lastName',
		// 	lastName,
		// 	'emailAddressPrincipal',
		// 	emailAddressPrincipal,
		// 	'name',
		// 	name
		// );

		if (firstName && lastName && emailAddressPrincipal) {
			// console.log('firstName && lastName && emailAddressPrincipal');
			displayName = `${firstName} ${lastName} - ${emailAddressPrincipal}`;
		} else if (firstName && lastName) {
			// console.log('firstName && lastName');
			displayName = `${firstName} ${lastName}`;
		} else if (emailAddressPrincipal) {
			// console.log('emailAddressPrincipal');
			displayName = emailAddressPrincipal;
		} else {
			// console.log('else');
			displayName = `${user && user.summary
				? user.summary.sortingName
				: user.text}`;
		}
		return `<span>${displayName}</span>`;
	}
}
